import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=1b753aee&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=1b753aee&prod&scoped=true&lang=css"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&id=1b753aee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b753aee",
  null
  
)

export default component.exports